var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.631836,
    width: 111,
    height: 111,
    rx: 15.5,
    fill: "#EEF4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.631836,
    width: 111,
    height: 111,
    rx: 15.5,
    stroke: "#C7D7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 32.7985H39.3333M39.3333 32.7985H52.6667C52.6667 42.6689 47.304 51.2868 39.3333 55.8976M39.3333 32.7985L39.3333 26.1318M39.3333 55.8976C35.411 58.1666 30.8572 59.4652 26 59.4652M39.3333 55.8976C35.285 53.5558 31.9094 50.1802 29.5675 46.1318M39.3333 55.8976C43.2556 58.1666 47.8095 59.4652 52.6667 59.4652M86 86.1318V85.922C86 82.6109 85.6498 79.3305 84.9672 76.1318M59.3333 86.1318V85.922C59.3333 82.6109 59.6836 79.3305 60.3661 76.1318M60.3661 76.1318C61.8797 69.0389 65.0273 62.3477 69.6138 56.6146C71.1789 54.6582 74.1544 54.6582 75.7195 56.6146C80.306 62.3477 83.4536 69.0389 84.9672 76.1318M60.3661 76.1318H84.9672",
    stroke: "#4C60E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageImg);
export default __webpack_public_path__ + "static/media/languageImg.54bf329faff9146bd431822b26a8c51f.svg";
export { ForwardRef as ReactComponent };